"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnWidthsFromProperties = exports.getDataPointsConfiguration = exports.getHighchartsAxisNameConfiguration = exports.removeImmutableOptionalStackingProperties = exports.isDualAxisOrSomeSecondaryAxisMeasure = exports.isStackingToPercent = exports.isStackingMeasure = exports.getReferencePointWithSupportedProperties = exports.getSupportedProperties = exports.isEmptyObject = exports.setSecondaryMeasures = exports.hasColorMapping = exports.getSupportedPropertiesControls = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
// eslint-disable-next-line no-restricted-imports -- unfortunately, the get syntax is used heavily here for the supported properties
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var has_1 = tslib_1.__importDefault(require("lodash/has"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var keys_1 = tslib_1.__importDefault(require("lodash/keys"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var axis_1 = require("../constants/axis");
var bucketHelper_1 = require("./bucketHelper");
var properties_1 = require("../constants/properties");
var uiConfig_1 = require("../constants/uiConfig");
var supportedProperties_1 = require("../constants/supportedProperties");
function getSupportedPropertiesControls(visualizationControlsProperties, supportedPropertiesList) {
    var clonedControls = cloneDeep_1.default(visualizationControlsProperties);
    if (supportedPropertiesList) {
        return supportedPropertiesList.reduce(function (props, current) {
            return has_1.default(clonedControls, current) ? set_1.default(props, current, get_1.default(clonedControls, current)) : props;
        }, {});
    }
    return {};
}
exports.getSupportedPropertiesControls = getSupportedPropertiesControls;
function hasColorMapping(properties) {
    var _a;
    return !!((_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a.colorMapping);
}
exports.hasColorMapping = hasColorMapping;
function setSecondaryMeasures(referencePoint, axisName) {
    var _a;
    var _b, _c, _d;
    if (!axisName) {
        return referencePoint;
    }
    var newReferencePoint = cloneDeep_1.default(referencePoint);
    var path = properties_1.PROPERTY_CONTROLS + "." + axisName;
    var secondaryAxisProperties = (_c = (_b = newReferencePoint === null || newReferencePoint === void 0 ? void 0 : newReferencePoint.properties) === null || _b === void 0 ? void 0 : _b.controls) === null || _c === void 0 ? void 0 : _c[axisName];
    var buckets = (_d = newReferencePoint === null || newReferencePoint === void 0 ? void 0 : newReferencePoint.buckets) !== null && _d !== void 0 ? _d : [];
    var allMeasures = bucketHelper_1.getMeasureItems(buckets);
    var secondaryMeasures = bucketHelper_1.getAllMeasuresShowOnSecondaryAxis(buckets);
    if (!secondaryAxisProperties && !secondaryMeasures.length) {
        return referencePoint;
    }
    var secondaryAxis = tslib_1.__assign(tslib_1.__assign({}, secondaryAxisProperties), { measures: bucketHelper_1.getItemsLocalIdentifiers(secondaryMeasures) });
    var axis = (_a = {
            0: axis_1.AXIS.PRIMARY
        },
        _a[allMeasures.length] = axis_1.AXIS.SECONDARY,
        _a)[secondaryMeasures.length] || axis_1.AXIS.DUAL;
    set_1.default(newReferencePoint, path, secondaryAxis);
    set_1.default(newReferencePoint, uiConfig_1.UICONFIG_AXIS, axis);
    return newReferencePoint;
}
exports.setSecondaryMeasures = setSecondaryMeasures;
function isEmptyObject(obj) {
    return obj && keys_1.default(obj).length === 0;
}
exports.isEmptyObject = isEmptyObject;
function getSupportedProperties(visualizationProperties, supportedPropertiesList) {
    var _a;
    var controls = (_a = visualizationProperties === null || visualizationProperties === void 0 ? void 0 : visualizationProperties.controls) !== null && _a !== void 0 ? _a : {};
    var supportedControls = getSupportedPropertiesControls(controls, supportedPropertiesList);
    return isEmpty_1.default(supportedControls)
        ? {}
        : {
            controls: supportedControls,
        };
}
exports.getSupportedProperties = getSupportedProperties;
function getReferencePointWithSupportedProperties(referencePoint, supportedPropertiesList) {
    var _a;
    var supportedControlsProperties = referencePoint.properties
        ? getSupportedPropertiesControls(referencePoint.properties.controls, supportedPropertiesList)
        : {};
    if (isEmpty_1.default(supportedControlsProperties)) {
        var sortItems = referencePoint.properties && referencePoint.properties.sortItems;
        var sortItemsExpand = sortItems && !isEmpty_1.default(sortItems) ? { sortItems: sortItems } : {};
        return tslib_1.__assign(tslib_1.__assign({}, referencePoint), { properties: tslib_1.__assign({}, sortItemsExpand) });
    }
    var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
    var stackCount = bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.STACK);
    var stackMeasuresToPercent = Boolean(supportedControlsProperties.stackMeasuresToPercent);
    if (!stackCount && stackMeasuresToPercent) {
        supportedControlsProperties.stackMeasures = true;
    }
    return tslib_1.__assign(tslib_1.__assign({}, referencePoint), { properties: tslib_1.__assign(tslib_1.__assign({}, referencePoint.properties), { controls: supportedControlsProperties }) });
}
exports.getReferencePointWithSupportedProperties = getReferencePointWithSupportedProperties;
function isStackingMeasure(properties) {
    var _a, _b;
    return (_b = (_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a.stackMeasures) !== null && _b !== void 0 ? _b : false;
}
exports.isStackingMeasure = isStackingMeasure;
function isStackingToPercent(properties) {
    var _a, _b;
    return (_b = (_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a.stackMeasuresToPercent) !== null && _b !== void 0 ? _b : false;
}
exports.isStackingToPercent = isStackingToPercent;
function isDualAxisOrSomeSecondaryAxisMeasure(extReferencePoint, secondaryMeasures) {
    var _a, _b, _c;
    return (((_c = (_b = (_a = extReferencePoint === null || extReferencePoint === void 0 ? void 0 : extReferencePoint.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.dualAxis) !== null && _c !== void 0 ? _c : true) ||
        secondaryMeasures.some(function (item) { return item === null || item === void 0 ? void 0 : item.showOnSecondaryAxis; }));
}
exports.isDualAxisOrSomeSecondaryAxisMeasure = isDualAxisOrSomeSecondaryAxisMeasure;
function removeImmutableOptionalStackingProperties(referencePoint, supportedPropertiesList) {
    var _a;
    var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
    var immutableProperties = [];
    if (bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.MEASURES) <= 1) {
        immutableProperties = supportedProperties_1.OPTIONAL_STACKING_PROPERTIES;
    }
    if (bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.STACK)) {
        immutableProperties = supportedProperties_1.OPTIONAL_STACKING_PROPERTIES.slice(0, 1);
    }
    return supportedPropertiesList.filter(function (property) {
        return !immutableProperties.some(function (immutableProperty) { return immutableProperty === property; });
    });
}
exports.removeImmutableOptionalStackingProperties = removeImmutableOptionalStackingProperties;
// mapping between AD and SDK values
var AXIS_NAME_POSITION_MAPPING = {
    auto: "middle",
    bottom: "low",
    middle: "middle",
    top: "high",
    left: "low",
    center: "middle",
    right: "high",
};
var AXIS_TYPES = ["xaxis", "yaxis", "secondary_xaxis", "secondary_yaxis"];
function getHighchartsAxisNameConfiguration(controlProperties, enableAxisNameConfiguration) {
    if (enableAxisNameConfiguration === void 0) { enableAxisNameConfiguration = false; }
    var axisProperties = AXIS_TYPES.reduce(function (result, axis) {
        var _a;
        var axisNameConfig = (_a = controlProperties === null || controlProperties === void 0 ? void 0 : controlProperties[axis]) === null || _a === void 0 ? void 0 : _a.name;
        if (isEmpty_1.default(axisNameConfig)) {
            return result;
        }
        axisNameConfig.position =
            AXIS_NAME_POSITION_MAPPING[enableAxisNameConfiguration ? axisNameConfig.position : AXIS_NAME_POSITION_MAPPING.auto];
        result[axis] = tslib_1.__assign(tslib_1.__assign({}, controlProperties[axis]), { name: axisNameConfig });
        return result;
    }, {});
    return tslib_1.__assign(tslib_1.__assign({}, controlProperties), axisProperties);
}
exports.getHighchartsAxisNameConfiguration = getHighchartsAxisNameConfiguration;
function getDataPointsConfiguration(controlProperties, enableHidingOfDataPoints) {
    var _a;
    if (enableHidingOfDataPoints === void 0) { enableHidingOfDataPoints = false; }
    if (enableHidingOfDataPoints) {
        var dataPointsVisible = (_a = controlProperties.dataPoints) === null || _a === void 0 ? void 0 : _a.visible;
        return tslib_1.__assign(tslib_1.__assign({}, controlProperties), { dataPoints: {
                visible: dataPointsVisible !== undefined ? dataPointsVisible : "auto",
            } });
    }
    return tslib_1.__assign(tslib_1.__assign({}, controlProperties), { dataPoints: {
            visible: undefined,
        } });
}
exports.getDataPointsConfiguration = getDataPointsConfiguration;
function getColumnWidthsFromProperties(visualizationProperties) {
    var _a;
    return (_a = visualizationProperties === null || visualizationProperties === void 0 ? void 0 : visualizationProperties.controls) === null || _a === void 0 ? void 0 : _a.columnWidths;
}
exports.getColumnWidthsFromProperties = getColumnWidthsFromProperties;
//# sourceMappingURL=propertiesHelper.js.map